import { Grid } from '@mui/material';
import { PropsFor } from '@mui/system';

export const FormFieldContainer = (props: PropsFor<typeof Grid>) => {
  return <Grid item xs={12} md={props.md} {...props} />;
};
